
import { defineComponent,ref } from 'vue';
import PassengerInfo from '@/components/BuyTicket/PassengerInfo/Index.vue';
import PayOrder from '@/components/BuyTicket/PayOrder.vue';
import Complete from '@/components/BuyTicket/Complete.vue';

export default defineComponent({
  components: {
		PassengerInfo,
    PayOrder,
    Complete,
  },
	setup() {
		//顶部进程标志
    let flag1 = ref(true);
    let flag2 = ref(false);
    let flag3 = ref(false);
		//买票各个阶段的标志
    let status1 = ref(true);
    let status2 = ref(false);
    let status3 = ref(false);
		//传给子组件的方法
		const next1 = () => {
			flag2.value = true;
			status1.value = false;
			status2.value = true;
		}
		const next2 = () => {
			flag3.value = true;
			status2.value = false;
			status3.value = true;
		}
    const order = ref(null);
    const getOrder = (newOrder: Object) => {
      (order.value as any) = newOrder;
      console.log(order.value);
    }
    return {
      flag1,
      flag2,
      flag3,
			status1,
			status2,
			status3,
      next1,
      next2,
      getOrder,
      order,
    };
  },
});
